module.exports = __webpack_public_path__ + "static/media/9.876266f8.jpg";